<div
  *ngIf="notificationState$ | async as state"
  class="smart-device-notifications-container mat-elevation-z2"
  scrollNearEnd
  (scrolledToBottom)="state.loadingMore ? null : onNearEndScroll(state.meta.next_cursor)">
  <h3>Notifications</h3>

  <ng-container *ngIf="!state.loading && !state.error">
    <section *ngIf="state.data.length" class="notifications-container">
      <div *ngFor="let notification of state.data; trackBy: trackNotificationsByFn" class="notification-container">
        <img
          class="notification-icon"
          [src]="'/assets/iconography/smart-devices/notifications/' + notification.type + '.svg'" />

        <div class="notification-message">{{ notification.message }}</div>

        <div class="notification-date" [matTooltip]="notification.created_at | date: 'long'">
          {{ notification.created_at | timeAgo }}
        </div>

        <mat-icon class="clickable smoke-darker" (click)="markNotificationAsRead(notification.id)">close</mat-icon>
      </div>

      <mat-spinner *ngIf="state.loadingMore" diameter="24"></mat-spinner>
    </section>

    <section *ngIf="!state.data.length">No notifications yet</section>
  </ng-container>

  <section *ngIf="state.loading" class="notifications-loading">
    <mat-spinner diameter="24"></mat-spinner>
  </section>

  <section *ngIf="state.error">
    <p>{{ state.error }}</p>
  </section>
</div>
